module.exports = function(app) {
    app.factory('isTruthyOrZero', function() {

        return function(value) {
            return value === 0 || !!value;
        };
    });
};